import React from "react";

// Components
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {PostViewFeature} from "../../features/postView";

const PostPage = () => (
  <FormPageLayout
    body={
      <PostViewFeature />
    }
  />
);

export default PostPage;
